import { Modal, Typography } from 'antd'
import { ComponentType } from 'react'
import { TaskTypes } from '../../types/api/task'
import { TASK_CREATION_FORMS } from './registry'
import {
    SupportedTaskCreationType,
    TaskCreationFormProps,
    TaskCreationWizardProps,
} from './types'

const isSupportedTaskCreationType = (type: TaskTypes): type is SupportedTaskCreationType =>
    type in TASK_CREATION_FORMS

function TaskCreationWizard<T extends TaskTypes>({
    open,
    type,
    initialValues,
    onClose,
    onSuccess,
}: TaskCreationWizardProps<T>) {
    const FormComponent = isSupportedTaskCreationType(type)
        ? (TASK_CREATION_FORMS[type] as ComponentType<
              TaskCreationFormProps<SupportedTaskCreationType>
          >)
        : null

    const handleSuccess = () => {
        onSuccess?.()
        onClose()
    }

    return (
        <Modal
            title='Мастер создания задач'
            open={open}
            footer={null}
            destroyOnClose
            onCancel={onClose}
        >
            {FormComponent ? (
                <FormComponent
                    initialValues={initialValues}
                    onSuccess={handleSuccess}
                    onCancel={onClose}
                />
            ) : (
                <Typography.Text type='secondary'>
                    Форма для этого типа задачи пока не реализована
                </Typography.Text>
            )}
        </Modal>
    )
}

export default TaskCreationWizard
